<script lang="ts">
	import ImageScroller from "$lib/embeds/ImageScroller.svelte";
</script>

<ImageScroller />
